var cookieName = "GH";
// const cookieName: string = "🦍";
export default cookieName;
